/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'
import { UNIT_TYPES } from 'constants'
import { FORT_BATTLE } from 'helpers/i18n.jsx'

export const BATTLE_ROOMS_UNIT_TOOLTIP_ID = 'UNIT_TOOLTIP_ID'

export const UNIT_TOOLTIP_CREATION_TIME = (time) => (
    <FormattedMessage
        id="battle_rooms.unit_tooltip.creation_time"
        defaultMessage="Набор открыт {time} назад"
        values={{ time }}
    />
)

export const UNIT_TOOLTIP_DISABLED_TEXT = (
    <FormattedMessage
        id='units_list.tooltips.disabled_unit'
        defaultMessage='Набор в состав отряда закрыт'
    />
)

export const UNIT_TOOLTIP_DATA_LABELS = {
    commander: (
        <FormattedMessage
            id="battle_rooms.unit_tooltip.commander"
            defaultMessage="Командир отряда"
        />
    ),
    battles: (
        <FormattedMessage
            id="battle_rooms.unit_tooltip.battles"
            defaultMessage="Бои в этом режимe"
        />
    ),
    wins: (
        <FormattedMessage
            id="battle_rooms.unit_tooltip.wins"
            defaultMessage="Победы"
        />
    ),
}

export const UNIT_TOOLTIP_BATTLE_MODE = {
    [UNIT_TYPES.SORTIE]: (level) => (
        <FormattedMessage
            id="battle_rooms.unit_tooltip.sortie_mode"
            defaultMessage="Вылазка в {level} дивизионе"
            values={{ level }}
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: () => FORT_BATTLE,
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitTooltip/constants.jsx